<agpr-dialog-container
    [id]="id"
    heading="Social.addSocialTopicsToThemeDialog.heading"
    (close)="closeDialog()"
>
    <div class='agpr-addAgentsToThemeDialog-content'>
        <!-- @TODO: remove this when we figure out proper way to handle -->
        @if (themeReachLimit) {
            <agpr-message [severity]="messageSeverityEnum.error">
                {{ 'Social.addSocialTopicsToThemeDialog.error' | localize }}
            </agpr-message>
        }

        <agpr-autocomplete
            [id]="id + '_themeAutoComplete'"
            labelField="name"
            label="Social.addSocialTopicsToThemeDialog.theme"
            [placeholder]="'Social.manageTopicsDialog.addToTheme'"
            [dropdown]="true"
            [(ngModel)]="selectedTheme"
            (itemSelected)="selectTheme()"
            [suggestions]="themeList$"
            [multiSelection]="false"
            [clearOnBlur]="false"
        ></agpr-autocomplete>

        <p class="agpr-addAgentsToThemeDialog-message">
            {{ 'Social.addSocialTopicsToThemeDialog.message' | localize }}
        </p>
        <agpr-scroll-panel>
            @if (agentsToAdd && agentsToAdd.length > 0) {
                <ul class='agpr-list'>
                    @for (agent of agentsToAdd; track agent.id) {
                        <li class='agpr-list-item'>
                            <span class="agpr-list-bullet fa fa-circle" aria-hidden="true"></span>
                                {{ agent.name }}
                        </li>
                    }
                </ul>
            }
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '_confirmButton'"
            label="Social.addSocialTopicsToThemeDialog.addButton"
            [style]="buttonTypes.primary"
            [disabled]="!selectedTheme || themeReachLimit"
            (click)="addAgentsToTheme()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
